import styles from '@ui/components/Counter/Counter.module.scss';
import Button from '@ui/components/Button/Button';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Counter = ({
  children,
  onAction,
  count,
  max,
  min,
  i18n,
  isNumberOnly = false,
  noMargin = false,
}) => {
  const incRef = useRef();
  const decRef = useRef();

  const handleAction = action => () => {
    if (action === 'increment') {
      incRef.current.focus();
    } else {
      decRef.current.focus();
    }
    onAction(action);
  };

  return (
    <div
      className={classNames(styles.container, {
        [styles.noMargin]: noMargin,
      })}
    >
      <Button
        aria-label={i18n?.decrement || 'verringern'}
        className={styles.navigation}
        data-purpose="decrement"
        disabled={(min || min === 0) && count === min}
        onClick={handleAction('decrement')}
        ref={decRef}
        shape="squared"
        theme="tertiary"
        variant="outline"
      >
        <FontAwesomeProIcon
          className={styles.icon}
          icon="minus"
          role="presentation"
          type="solid"
        />
      </Button>
      <div
        className={classNames(
          {
            [styles.numberOnly]: isNumberOnly,
          },
          styles.content,
        )}
      >
        {children}
      </div>
      <Button
        aria-label={i18n?.increment || 'erhöhen'}
        className={styles.navigation}
        data-purpose="increment"
        disabled={max && count === max}
        onClick={handleAction('increment')}
        ref={incRef}
        shape="squared"
        theme="tertiary"
        variant="outline"
      >
        <FontAwesomeProIcon
          className={styles.icon}
          icon="plus"
          role="presentation"
          type="solid"
        />
      </Button>
    </div>
  );
};

Counter.propTypes = {
  children: PropTypes.node.isRequired,
  count: PropTypes.number.isRequired,
  i18n: PropTypes.shape({
    increment: PropTypes.string,
    decrement: PropTypes.string,
  }),
  isNumberOnly: PropTypes.bool,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  noMargin: PropTypes.bool,
  onAction: PropTypes.func.isRequired,
};

export default Counter;
